import React from 'react'
import { dict } from '@components/Translate'
import Typography from '@material-ui/core/Typography'

export default function TypographyComponent(props) {
  const { params = {}, children, html } = props
  const value = dict.translate(children, params)
  return <Typography {...props}>{html ? <span dangerouslySetInnerHTML={{ __html: value }} /> : value}</Typography>
}
